import { createTheme, getDefaultZIndex, Menu, Modal, Popover, Select } from '@mantine/core'

/** z-index for overlays so they appear above floating chat panels (1100) */
export const OVERLAY_Z_INDEX = 1200
export const MODAL_Z_INDEX = 1300
/** Select/Combobox dropdowns inside modals must sit above the modal layer. */
export const DROPDOWN_ABOVE_MODAL_Z_INDEX = MODAL_Z_INDEX + 100

/** Mantine Select combobox props for dropdowns opened inside modals (matches desktop AssistantEditor). */
export const selectComboboxAboveModal = {
  withinPortal: true,
  zIndex: getDefaultZIndex('max'),
} as const

/** Mirrors owlbert `mainwindow.tsx` Mantine theme (non-pro desktop). */
export const owlbertWebTheme = createTheme({
  /** Desktop Owlbert uses `#6c5ce7` as the primary action purple in dark mode. */
  primaryColor: 'violet',
  fontFamily: '"Reddit Sans", -apple-system, BlinkMacSystemFont, sans-serif',
  fontFamilyMonospace: '"IBM Plex Mono", "SF Mono", "Monaco", "Consolas", "Courier New", monospace',
  headings: {
    fontFamily: '"Reddit Sans", -apple-system, BlinkMacSystemFont, sans-serif',
  },
  defaultRadius: 'md',
  components: {
    Popover: Popover.extend({
      defaultProps: { zIndex: OVERLAY_Z_INDEX },
    }),
    Menu: Menu.extend({
      defaultProps: { zIndex: OVERLAY_Z_INDEX },
    }),
    Modal: Modal.extend({
      defaultProps: { zIndex: MODAL_Z_INDEX },
    }),
    Select: Select.extend({
      defaultProps: {
        comboboxProps: selectComboboxAboveModal,
      },
    }),
  },
})
